import Image from 'next/image';

interface BackgroundBannerImageProps {
  className?: string;
  alt?: string;
  priority?: boolean;
}

export const BackgroundBannerImage = ({
  alt = '',
  priority = true,
  className,
}: BackgroundBannerImageProps) => {
  // TODO: update blue_banner.svg to not be massive and refactor this component to use <BlueBanner /> instead.
  //       Current implementation clashes with loki visual regression testing - stopping us from using this component in our stories
  return (
    <Image
      className={className}
      src="/blue_banner.svg"
      fill
      alt={alt}
      priority={priority}
      style={{
        objectFit: 'cover',
        maxWidth: '100%',
      }}
    />
  );
};

export default BackgroundBannerImage;
